import React from 'react'

export const base_url = 'https://www.sae-mallorca.com/propertywebsite/api'

export const property_base_url = 'https://www.sae-mallorca.com/propertywebsite/'